import React, { useRef, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { EditManySellersActions } from '../../../constants/editManySeller';
import useSellers from '../../../hooks/useSellers';
import SellerStatusSelection from './SellerStatusSelection';
import { IEditManyHandler } from '../../../contexts/sellersContext';
import IntegratorCommercialConsultantsEditMany from './IntegratorCommercialConsultants';

interface EditManyModalProps {
    show: boolean;
    onHide: () => void;
    onSave: () => void;
    onExecuteHandler?: (handler: IEditManyHandler) => void;
}

const EditManyModal: React.FC<EditManyModalProps> = ({
    show,
    onHide,
    onSave,
    onExecuteHandler,
}) => {

    const handlerRef = useRef<IEditManyHandler | null>(null);
    const { actionToEditForm } = useSellers();
    const action = actionToEditForm.getValues().action?.value;

    const [integrator, setIntegrator] = useState<number[]>([]);
    const [integratorSelected, setIntegratorSelected] = useState<number>();

    const handleCommercialConsultantsChange = (value: number[]) => {
        if (value.length <= 0)
            return

        setIntegrator(value);
        setIntegratorSelected(value[0]);
    };

    const handleSave = async () => {
        if (handlerRef.current) {
            await onExecuteHandler?.(handlerRef.current);
        }
        onSave();
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Selecione o novo valor</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {action === EditManySellersActions.Consultor && (
                    <IntegratorCommercialConsultantsEditMany
                        selectedCommercialConsultant={integratorSelected ?? null}
                        selectedCommercialConsultants={integrator}
                        onCommercialConsultantsChange={handleCommercialConsultantsChange}
                        // eslint-disable-next-line no-return-assign, no-param-reassign
                        onRef={(handler) => (handlerRef.current = handler)}
                    />
                )}
                {action === EditManySellersActions.Status && (
                    <SellerStatusSelection
                        control={actionToEditForm.control}
                        name="newStatus"
                        // eslint-disable-next-line no-return-assign, no-param-reassign
                        onRef={(handler) => (handlerRef.current = handler)}
                    />
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handleSave} style={{ width: '100%' }}>
                    Executar edição em massa
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditManyModal;
